import React from 'react';
import { FormattedMessage } from 'react-intl';

import Text from 'ui/Text';
import PageTitle from 'shared/PageTitle';

const Faqs = props => (
  <div className="faq-section inner-content">
    <PageTitle title="FAQs" />
    <Text type="heading" modifiers="uppercase medium explainer-title primary-blue">
      <FormattedMessage id="FAQ.Title" defaultMessage="BEFORE YOU APPLY" />
    </Text>
    <ol className="faq-list">
      <li className="faq-list__item">
        <Text type="normal-semi-bold" modifiers="normal__larger question">
          <FormattedMessage
            id="FAQ.Section11.Title"
            defaultMessage="Why do the Awards focus on capacity building?"
          />
        </Text>
        <Text type="explanation" modifiers="answer">
          <FormattedMessage
            id="FAQ.Section11.Explanation"
            defaultMessage="Organizational capacity is integral to success, and we believe that it should be a priority, a strategic investment to ensure program quality and implementation.To quote Kathy Reich of the Ford Foundation’s BUILD Initiative,“Strong programs exist in strong organizations, and the strongest nonprofits are adaptable and resilient. They have effective leaders, good financial management, the ability to collaborate with others, and the space to plan, execute and assess new strategies. Capacity building is what allows nonprofits to build these skills and expertise — and more — so that they have what it takes to tackle deep-rooted problems.”"
          />
        </Text>
      </li>
      <li className="faq-list__item">
        <Text type="normal-semi-bold" modifiers="normal__larger question">
          <FormattedMessage id="FAQ.Section1.Title" defaultMessage="Why these Awards?" />
        </Text>
        <Text type="explanation" modifiers="answer">
          <FormattedMessage
            id="FAQ.Section1.Explanation"
            defaultMessage="The African CSO Excellence Awards give public recognition to the amazing work that African CSOs are doing despite daunting challenges. By bringing greater visibility to effective African CSOs, the awards:"
          />
          <ul className="sub-points">
            <li>
              <FormattedMessage
                id="FAQ.Section1.Point.1"
                defaultMessage="Demonstrate CSO accountability and transparency"
              />
            </li>
            <li>
              <FormattedMessage
                id="FAQ.Section1.Point.2"
                defaultMessage="Strengthen CSO legitimacy and local support"
              />
            </li>
            <li>
              <FormattedMessage
                id="FAQ.Section1.Point.3"
                defaultMessage="Make it easier for donors to find partners"
              />
            </li>
          </ul>
        </Text>
      </li>
      <li className="faq-list__item">
        <Text type="normal-semi-bold" modifiers="normal__larger question">
          <FormattedMessage
            id="FAQ.Section2.Title"
            defaultMessage="Is our organization eligible to apply for the African CSO Excellence Awards?"
          />
        </Text>
        <Text type="explanation" modifiers="answer">
          <FormattedMessage
            id="FAQ.Section2.Explanation"
            defaultMessage="All African civil society organizations that are legally registered as not-for-profit organizations or other classification of social purpose organizations in any of the 54 African countries are eligible to apply."
          />
        </Text>
      </li>
      <li className="faq-list__item">
        <Text type="normal-semi-bold" modifiers="normal__larger question">
          <FormattedMessage
            id="FAQ.Section3.Title"
            defaultMessage="What is the definition of an African CSO?"
          />
        </Text>
        <Text type="explanation" modifiers="answer">
          <FormattedMessage
            id="FAQ.Section3.Explanation"
            defaultMessage="All legally registered not-for-profit, or other classification of social purpose organization, founded and led by Africans, composed in majority of African staff and working on major challenges impacting Africa able to apply. Under this definition, international NGOs operating in Africa are not eligible to apply for the awards but their local partners who fit the definition are encouraged to apply."
          />
        </Text>
      </li>
      <li className="faq-list__item">
        <Text type="normal-semi-bold" modifiers="normal__larger question">
          <FormattedMessage
            id="FAQ.Section4.Title"
            defaultMessage="How will winners be selected?"
          />
        </Text>
        <Text type="explanation" modifiers="answer">
          <FormattedMessage
            id="FAQ.Section4.Explanation"
            defaultMessage="EPIC-Africa evaluates the organizational capacity of CSOs across 8 key categories: "
          />
          <i>
            <FormattedMessage
              id="FAQ.Section4.Explanation.2"
              defaultMessage="Strategic Ability and Adaptability, Leadership and Governance, Financial Health and Management, Human Resources and Staff Development, Operations, Communications, Partnerships and Alliances, Monitoring and Evaluation. "
            />
          </i>
          <FormattedMessage
            id="FAQ.Section4.Explanation.3"
            defaultMessage="Applicants will be ranked according to how well they score across these 8 categories."
          />
          <br />
          <br />
          <FormattedMessage
            id="FAQ.Section4.Explanation.4"
            defaultMessage="Applicants submit the required information through a web-portal from October 15 to December 31st, 2018. The selection process consists of three steps:"
          />
          <ul className="sub-points">
            <li>
              <FormattedMessage
                id="FAQ.Section4.Point.1"
                defaultMessage="Step 1: All applicants will be ranked according to their score across the 8 categories of assessment to produce a shortlist of 90 CSOs."
              />
            </li>
            <li>
              <FormattedMessage
                id="FAQ.Section4.Point.2"
                defaultMessage="Step 2: The top five CSOs from each category will advance to a short-list of 45 and undergo a more thorough assessment including interviews, reference checks and where feasible, site visits."
              />
            </li>
            <li>
              <FormattedMessage
                id="FAQ.Section4.Point.3"
                defaultMessage="Step 3: A panel of experts from the philanthropy sector will select the top 9 winners."
              />
            </li>
          </ul>
        </Text>
      </li>
      <li className="faq-list__item">
        <Text type="normal-semi-bold" modifiers="normal__larger question">
          <FormattedMessage
            id="FAQ.Section5.Title"
            defaultMessage="What is the deadline to apply for the African CSO Excellence Awards?"
          />
        </Text>
        <Text type="explanation" modifiers="answer">
          <FormattedMessage
            id="FAQ.Section5.Explanation"
            defaultMessage="Applications will be open from October 15th – December 31, 2018. Applications received after December 31st will not be considered."
          />
        </Text>
      </li>
      <li className="faq-list__item">
        <Text type="normal-semi-bold" modifiers="normal__larger question">
          <FormattedMessage
            id="FAQ.Section6.Title"
            defaultMessage="What are the benefits of applying for the African CSO Excellence Awards?"
          />
        </Text>
        <Text type="explanation" modifiers="answer">
          <FormattedMessage
            id="FAQ.Section6.Point.1"
            defaultMessage="Your organization will get an opportunity to fundraise on the international GlobalGiving Platform with a series of capacity building workshops for 3 members of staff. "
          />
          <br /><br />
          <FormattedMessage
            id="FAQ.Section6.Point.2"
            defaultMessage="You will get media visibility and networking opportunities through the African CSO Excellence Awards community. "
          />
          <br /><br />
          <FormattedMessage
            id="FAQ.Section6.SubPoint.Title"
            defaultMessage="The Awards also offer your organization the chance to:"
          />
          <ul className="sub-points">
            <li>
              <FormattedMessage
                id="FAQ.Section6.SubPoint.1"
                defaultMessage="Assess your organizational capacity."
              />
            </li>
            <li>
              <FormattedMessage
                id="FAQ.Section6.SubPoint.2"
                defaultMessage="Receive a confidential capacity diagnostic report to help benchmark your organization."
              />
            </li>
            <li>
              <FormattedMessage
                id="FAQ.Section6.SubPoint.3"
                defaultMessage="Increase your visibility to local and international funders."
              />
            </li>
            <li>
              <FormattedMessage
                id="FAQ.Section6.SubPoint.4"
                defaultMessage="Increase your credibility by demonstrating transparency and accountability."
              />
            </li>
          </ul>
        </Text>
      </li>
      <li className="faq-list__item">
        <Text type="normal-semi-bold" modifiers="normal__larger question">
          <FormattedMessage
            id="FAQ.Section7.Title"
            defaultMessage="Why are organizations required to share supporting documents?"
          />
        </Text>
        <Text type="explanation" modifiers="answer">
          <FormattedMessage
            id="FAQ.Section7.Explanation"
            defaultMessage="The only mandatory document that organizations are required to share is the certificate of registration to demonstrate proof of their legal status. Sharing of all other documents that are listed is optional. However, we strongly encourage you to share as many of these documents as possible. Sharing helps to demonstrate your transparency and boosts your score in the relevant category as we are better able to assess your application."
          />
          <ul className="sub-answer">
            <li className="sub-answer__item">
              <Text type="normal-semi-bold" modifiers="normal__larger question uppercase">
                <FormattedMessage id="FAQ.Section7.SubTitle.1" defaultMessage="Required" />
              </Text>
              <ul>
                <li>
                  <FormattedMessage
                    id="FAQ.Section7.SubTitle.1.Explanation"
                    defaultMessage="Certificate of Registration (Proof of legal registration
                  is required to be eligible to apply for the awards)"
                  />
                </li>
              </ul>
            </li>
            <li className="sub-answer__item">
              <Text type="normal-semi-bold" modifiers="normal__larger question">
                <FormattedMessage
                  id="FAQ.Section7.SubTitle.2"
                  defaultMessage="OPTIONAL (BUT STRONGLY ENCOURAGED)"
                />
              </Text>
              <ul>
                <li>
                  <FormattedMessage
                    id="FAQ.Section7.SubTitle.2.Point.1"
                    defaultMessage="Current strategic plan"
                  />
                </li>
                <li>
                  <FormattedMessage
                    id="FAQ.Section7.SubTitle.2.Point.2"
                    defaultMessage="Human resources manual or other staff development policies"
                  />
                </li>
                <li>
                  <FormattedMessage
                    id="FAQ.Section7.SubTitle.2.Point.3"
                    defaultMessage="Most recent audited financial statement"
                  />
                </li>
                <li>
                  <FormattedMessage
                    id="FAQ.Section7.SubTitle.2.Point.4"
                    defaultMessage="Financial management procedures or policies"
                  />
                </li>
                <li>
                  <FormattedMessage
                    id="FAQ.Section7.SubTitle.2.Point.5"
                    defaultMessage="Communications strategy"
                  />
                </li>
                <li>
                  <FormattedMessage
                    id="FAQ.Section7.SubTitle.2.Point.6"
                    defaultMessage="Most recent annual report"
                  />
                </li>
              </ul>
            </li>
          </ul>
        </Text>
      </li>
      <li className="faq-list__item">
        <Text type="normal-semi-bold" modifiers="normal__larger question">
          <FormattedMessage
            id="FAQ.Section9.Title"
            defaultMessage="How will my application information be used in this process?"
          />
        </Text>
        <Text type="explanation" modifiers="answer">
          <FormattedMessage
            id="FAQ.Section9.Explanation"
            defaultMessage="EPIC-Africa seeks to first and foremost use the information provided in the application process to help improve the civil society sector in Africa. Therefore, information provided by applicants will be used to:"
          />
          <ul className="sub-points">
            <li>
              <FormattedMessage
                id="FAQ.Section9.Point.1"
                defaultMessage="Shortlist candidates and determine the winners of the African CSO Excellence Awards."
              />
            </li>
            <li>
              <FormattedMessage
                id="FAQ.Section9.Point.2"
                defaultMessage="Produce data driven thought-pieces to contribute to knowledge on African CSOs."
              />
            </li>
            <li>
              <FormattedMessage
                id="FAQ.Section9.Point.3"
                defaultMessage="Facilitate donor access to CSOs on the continent."
              />
            </li>
            <li>
              <FormattedMessage
                id="FAQ.Section9.Point.4"
                defaultMessage="Faciliate peer to peer, cross country learning and sharing of best practices amongst African CSOs."
              />
            </li>
          </ul>
          <br />
          <FormattedMessage
            id="FAQ.Section9.Explanation.2"
            defaultMessage="EPIC-Africa adheres to stringent data protection policies. We do not sell data to third parties.  Furthermore, only publicly available information will be published on the platform, including:"
          />
          <ul className="sub-points">
            <li>
              <FormattedMessage
                id="FAQ.Section9.Point.5"
                defaultMessage="Name of your Organization."
              />
            </li>
            <li>
              <FormattedMessage
                id="FAQ.Section9.Point.7"
                defaultMessage="Typology of your Organization."
              />
            </li>
            <li>
              <FormattedMessage
                id="FAQ.Section9.Point.8"
                defaultMessage="Designated Focus Areas."
              />
            </li>
            <li>
              <FormattedMessage id="FAQ.Section9.Point.9" defaultMessage="Country Focus." />
            </li>
            <li>
              <FormattedMessage id="FAQ.Section9.Point.10" defaultMessage="Website link." />
            </li>
          </ul>
        </Text>
      </li>
      <li className="faq-list__item">
        <Text type="normal-semi-bold" modifiers="normal__larger question">
          <FormattedMessage
            id="FAQ.Section10.Title"
            defaultMessage="How does the African CSO Index relate to similar efforts to boost CSO effectiveness?"
          />
        </Text>
        <Text type="explanation" modifiers="answer">
          <FormattedMessage
            id="FAQ.Section10.Explanation"
            defaultMessage="Among existing African CSO databases, some of which include thousands of organizations, most provide only basic, directory-like information. There are also several assessment and accreditation efforts both on the continent and abroad that offer ideas for creating more detailed and robust profiles of CSOs. These efforts require considerable amounts of human labor and financial capacity and are therefore quite onerous for most CSOs. The African CSO Index differs in that it promotes the visibility of African CSOs and also gives you the tools to build your organization’s capacity."
          />
        </Text>
      </li>
      <li className="faq-list__item">
        <Text type="normal-semi-bold" modifiers="normal__larger question">
          <FormattedMessage id="FAQ.Section12.Title" defaultMessage="Is there a cost to enter?" />
        </Text>
        <Text type="explanation" modifiers="answer">
          <FormattedMessage
            id="FAQ.Section12.Explanation"
            defaultMessage="There is no cost to submit an entry for the African CSO Excellence Awards."
          />
        </Text>
      </li>
      <li className="faq-list__item">
        <Text type="normal-semi-bold" modifiers="normal__larger question">
          <FormattedMessage
            id="FAQ.Section13.Title"
            defaultMessage="Can we submit our entry by mail?"
          />
        </Text>
        <Text type="explanation" modifiers="answer">
          <FormattedMessage
            id="FAQ.Section13.Explanation"
            defaultMessage="We currently only accept entries via the EPIC-Africa platform."
          />
        </Text>
      </li>
      <li className="faq-list__item">
        <Text type="normal-semi-bold" modifiers="normal__larger question">
          <FormattedMessage
            id="FAQ.Section14.Title"
            defaultMessage="Any suggestions for a successful entry?"
          />
        </Text>
        <Text type="explanation" modifiers="answer">
          <ul className="sub-points">
            <li>
              <FormattedMessage
                id="FAQ.Section14.Point.1"
                defaultMessage="Read the questions carefully. Make sure that you understand what is asked. If you don’t understand something, contact support@epic-africa.org with your questions."
              />
            </li>
            <li>
              <FormattedMessage
                id="FAQ.Section14.Point.2"
                defaultMessage="Assemble a team which includes senior management – often, different people will be knowledgeable about different aspects of your organization and have access to different materials."
              />
            </li>
            <li>
              <FormattedMessage
                id="FAQ.Section14.Point.3"
                defaultMessage="Start early. Even though you have the opportunity to save your application and come back to it later, it helps to compile, review and have all your documents ready for the online entry before you start."
              />
            </li>
            <li>
              <FormattedMessage
                id="FAQ.Section14.Point.4"
                defaultMessage="Involve your marketing or communications contacts. They may have valuable input. And, if you win or are shortlisted, they can use the award in their materials to help your organization get additional visibility and to fundraise."
              />
            </li>
          </ul>
        </Text>
      </li>
      <li className="faq-list__item">
        <Text type="normal-semi-bold" modifiers="normal__larger question">
          <FormattedMessage
            id="FAQ.Section15.Title"
            defaultMessage="Where can I get support to fill out the application?"
          />
        </Text>
        <Text type="explanation" modifiers="answer">
          <FormattedMessage
            id="FAQ.Section15.Explanation"
            defaultMessage="Please feel free to contact the EPIC-Africa team at support@epic-africa.org from 9am – 5pm GMT, Monday to Friday for assistance."
          />
        </Text>
      </li>
    </ol>
  </div>
);

export default Faqs;



// WEBPACK FOOTER //
// ./src/components/HomePage/Faqs.js